import { Button, ModalBody, Modal, ModalHeader } from "reactstrap";
import {ReactComponent as WarningUnfilled} from "../../../../../images/warningUnfilled.svg"
import ModalCloseIcon from "../../../../../images/modal-close.svg";

interface IProps {
  confirmCloseModel:boolean;
  cancelHandler:Function;
  deleteHandler: Function;
  className?: string;
  modalToggle?: () => void;
}

const DeleteTemplateModal = (props: IProps) => {
  const closeBtn = (
    <button
      className="close"
      onClick={() => props.cancelHandler()}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    <Modal
      isOpen={props.confirmCloseModel}
      className={`ToasterPopUp ${props.className}`}
      toggle={props.modalToggle}
    >
      
        <ModalHeader close={closeBtn}>
        </ModalHeader>
      <ModalBody>
      <WarningUnfilled/>
      <p className="deleteHeading">Delete Templete?</p>
      <p className="text">Once this template is deleted, it will no longer be accessible. 
          <br/>Would you like to continue?
        </p>
        <div className="buttons">
          <Button className="cancel" onClick={() => props.cancelHandler()}>
            Cancel
          </Button>
          <Button className="delete" onClick={() => props.deleteHandler()}>
            Delete Template
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteTemplateModal;
